import type * as React from 'react'
import { Loader2Icon } from 'lucide-react'

import { cn } from '@repo/ui/lib/utils'

function Spinner({
  className,
  ...props
}: React.ComponentProps<typeof Loader2Icon>) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  )
}

export { Spinner }
